// (function (doc, win) {
//     var docEl = doc.documentElement;
//     resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
//     recalc = function () { var clientWidth = docEl.clientWidth;
//         if (!clientWidth) return;
//         docEl.style.fontSize = 50 * (clientWidth / 1920) + 'px';
//     };
//     if (!doc.addEventListener) return;
//     win.addEventListener(resizeEvt, recalc, false);
//     doc.addEventListener('DOMContentLoaded', recalc, false);
// }(document,window));

(function (docs, win) {
    var docEls = docs.documentElement,
        resizeEvts = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalcs = function () {

            //getBoundingClientRect()这个方法返回一个矩形对象
            window.rem = docEls.getBoundingClientRect().width/51.2;
            docEls.style.fontSize = window.rem + 'px';
            // console.log(docEls.style.fontSize)
        };
    recalcs();
    if (!docs.addEventListener) return;
    win.addEventListener(resizeEvts, recalcs, false);
})(document, window);
